import type { Locale } from './translations';

export const languagePersistenceCopy: Record<
  Locale,
  { saving: string; failed: string; retry: string; automatic: string }
> = {
  ro: {
    saving: 'Se salvează limba…',
    failed: 'Limba a fost schimbată aici, dar nu s-a salvat în cont.',
    retry: 'Încearcă din nou',
    automatic: 'Se salvează automat în cont.',
  },
  en: {
    saving: 'Saving language…',
    failed: 'The language changed here, but could not be saved to your account.',
    retry: 'Try again',
    automatic: 'Saved automatically to your account.',
  },
  hu: {
    saving: 'Nyelv mentése…',
    failed: 'A nyelv itt megváltozott, de nem sikerült menteni a fiókban.',
    retry: 'Újrapróbálkozás',
    automatic: 'Automatikusan mentjük a fiókba.',
  },
};
